import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft } from "lucide-react";

export function ConsultantNav({ onNext, onBack, nextLabel = "Continue", canBack = true, disabled = false, testId = "stage" }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 flex items-center justify-between px-6 md:px-12 py-5 pointer-events-none">
      <div className="pointer-events-auto">
        {canBack && (
          <button
            data-testid={`${testId}-back-btn`}
            onClick={onBack}
            className="hotspot group flex items-center gap-2 text-mutedText hover:text-forest transition-colors text-sm"
          >
            <ArrowLeft size={16} className="transition-transform group-hover:-translate-x-1" />
            Back
          </button>
        )}
      </div>
      <div className="pointer-events-auto">
        {onNext && (
          <button
            data-testid={`${testId}-next-btn`}
            onClick={onNext}
            disabled={disabled}
            className="hotspot group relative flex items-center gap-3 rounded-full bg-brand px-7 py-3.5 text-white text-sm font-medium tracking-wide shadow-xl shadow-forest/20 transition-all hover:bg-brand disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {nextLabel}
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </button>
        )}
      </div>
    </div>
  );
}

export function ProgressRail({ stages, current }) {
  const total = Math.max(stages.length - 1, 1);
  const pct = (current / total) * 100;
  const label = stages.find((s) => s.index === current);
  return (
    <div className="fixed top-0 left-0 right-0 z-30 pointer-events-none">
      <div className="h-[3px] w-full bg-line/60">
        <motion.div
          className="h-full bg-brand"
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
      <div className="flex items-center justify-between px-6 md:px-12 py-3">
        <span className="label-eyebrow text-forest/70">Stage 1 · {label?.title}</span>
        <span className="label-eyebrow text-mutedText">
          {String(current).padStart(2, "0")} / {String(total).padStart(2, "0")}
        </span>
      </div>
    </div>
  );
}
